import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import { useForm } from "react-hook-form";
import provisional from "../../Assets/images/provisional_landing_image.png";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as httpClient from "../../../util/httpClient";
import PSSBannerMessage from "../PSSBannerMessage/PSSBannerMessage";
import "../../Assets/css/_psslanding/retailer-pss-landing-page.scss";
import { Notification } from "../../../components/common/Notification";

const MyAccount = (props: any) => {
    const { i18n: i18nLang } = useTranslation();
    const location = useLocation();
    const partnerLanguageOptions = useSelector(
        (state: ApplicationState) => state.configurationState && state.configurationState.partnerLanguageOptions && state.configurationState.partnerLanguageOptions
    );
    const partnerID: number = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId
            : 0
    );
    const [configurableField, setConfigurableField] = useState("Last 4 digits of SSN");
    const [isLoading, setIsLoading] = useState(true);
    const query = new URLSearchParams(location.search);
    const RetailerCode: any = query.get("RetailerCode") || query.get("RETAILERCODE");
    const [isRetailerSpec, setRetailerSpec] = useState(false);
    const [renderComp, setRenderComp] = useState("");
    const [renderStyle, setRederStyle] = useState("");
    const [renderTitle, setRenderTitle] = useState("");
    const [showNotification, setShowNotification] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        setTimeout(() => {
            let language =
                !!partnerLanguageOptions && partnerLanguageOptions.length > 1
                    ? document.cookie.split(";").filter((cookieElement: string) => cookieElement.split("=")[0].trim() === "user_prefered_language").length > 0
                        ? !!document.cookie
                              .split(";")
                              .filter((cookieElement: string) => cookieElement.split("=")[0].trim() === "user_prefered_language")[0]
                              .split("=")[1]
                            ? document.cookie
                                  .split(";")
                                  .filter((cookieElement: string) => cookieElement.split("=")[0].trim() === "user_prefered_language")[0]
                                  .split("=")[1]
                            : "en"
                        : "en"
                    : "en";
            i18nLang.changeLanguage(language);
        }); 
    }, []);

    useEffect(() => {
        if (showNotification) {
            Notification({
                type: "error",
                title: "An Error has Occurred",
                message: "Something went wrong, Please try again.",
                duration: 10,
            });
            setShowNotification(false);
        }
    }, [showNotification]);

    useEffect(() => {
        setIsLoading(true);
        if (partnerID && RetailerCode) {
            const requestBody = {
                PartnerID: partnerID,
                RetailerCode: RetailerCode
            };
            httpClient
                .sendRequest("POST", "api/PssLandingPage/GetRetailerPSSSerData", requestBody)
                .then((data) => {
                    if (data?.key! == null || !data["HasError"]) {
                        setRetailerSpec(true);
                        setRederStyle(data.retailerPSSStyle);
                        setRenderComp(data.retailerPSSHTML);
                        setRenderTitle(data.retailerPSSTitle);

                        httpClient
                            .sendRequest("POST", "api/PssLandingPage/GetConfigurableFieldsPssLandingPage2", requestBody)
                            .then((data) => {
                                if (data.keyValue?.length) {
                                    setConfigurableField(data.keyValue);
                                }
                                setIsLoading(false);

                            }).catch((err) => {
                                setIsLoading(false);
                            });
                    }
                })
                .catch(function (error) {
                    setIsLoading(true);
                    setShowNotification(true);
                });

        } else if (partnerID) {
            const requestBody = {
                PartnerID: partnerID,
                RetailerCode: RetailerCode,
            }
            httpClient
                .sendRequest("POST", "api/PssLandingPage/GetConfigurableFieldsPssLandingPage2", requestBody)
                .then((data) => {
                    if (data.keyValue?.length) {
                        setConfigurableField(data.keyValue);
                    }
                    setIsLoading(false);

                }).catch((err) => {
                    setIsLoading(false);
                });
        }
       
    }, [partnerID]);



    const { register, errors, handleSubmit, reset, trigger} = useForm({
        mode: "onBlur",
        reValidateMode: "onChange",
        defaultValues: {
            firstName: "",
            lastName: "",
            zip: "",
            customerSecret: "",
        },
    });
    const [showAccessCodeField, setShowAccessCodeField] = useState(false);
    const [state, setState] = useState({
        firstName: "",
        lastName: "",
        zip: "",
        customerSecret: "",
        showErrorMessage: false,
        showAccessCodeField: true,
        errorMsg: "AccessCode is Required",
        isLoading: false,
    });
    const handleInputChange = (event: any) => {
        const target = event.target;
        const value = target.value === "checkbox" ? target.checked : target.value;
        const name = target.name;
        if (name === "") {
            setState({
                ...state,
                [name]: value,
                showErrorMessage: false,
            });
        } else {
            setState({
                ...state,
                [name]: value,
            });
        }
    };

    const onSubmit = (data: any) => {
        setShowAccessCodeField(false);
        setState({ ...state, isLoading: true, showErrorMessage: true });
        const requestBody = {
            customerSecret: data.customerSecret,
            firstName: data.firstName,
            lastName: data.lastName,
            zip: data.zip,
            partnerID: partnerID,
        };
        httpClient
            .sendRequest("POST", "api/PssLandingPage/GetPssLandingPage2?enrollFileRequired=true", requestBody)
            .then((data) => {
                if (data.provisionalResponseLanding.length === 0) {
                    setShowAccessCodeField(true);
                } else if (data.provisionalResponseLanding.length !== 0) {
                    if (isRetailerSpec) {
                        props.history.push({
                            pathname:
                                "/Register?Type=" +
                                data.provisionalResponseLanding[0].contractStatus +
                                "&VALUE=" +
                                data.provisionalResponseLanding[0].provisionalID +
                                "&RETAILERCODE=" +
                                RetailerCode +
                                "&GNDNRLL=PSS2",
                        });
                    } else {
                        props.history.push({
                            pathname:
                                "/Register?Type=" +
                                data.provisionalResponseLanding[0].contractStatus +
                                "&VALUE=" +
                                data.provisionalResponseLanding[0].provisionalID +
                                "&GNDNRLL=PSS2",
                        });
                    }
                   
                    window.location.reload();
                }
            })
            .catch(function (error) {
                reset();
                trigger();
                setState({ ...state, showErrorMessage: true, errorMsg: "Something went wrong. Please try again.", isLoading: false });
            });
    };
    const handleClick = () => {
        handleSubmit(onSubmit);
        window.addToDataLayer({ event: "PSS2 Get Started" });
    }
    const handleAccessCode = () => {
            props.history.push({
                pathname: "ProvisionalResponseLandingPage1",
            });
    };
    if (isLoading) {
        return (
            <div className="col-xs">
                <div className={`loading`}></div>
            </div>
        );
    } else {
        return (
            <React.Fragment>
              
                {!isRetailerSpec ?
                    <>
                    { showAccessCodeField === true ? (
                        <PSSBannerMessage layout={"psslandingcode"} showAccessCodeField={showAccessCodeField} setShowAccessCodeField={setShowAccessCodeField} />
                    ) : errors.lastName || errors.firstName || errors.zip || errors.customerSecret ? (
                        <PSSBannerMessage layout={"psslandingerrormessage"} showAccessCodeField={showAccessCodeField} setShowAccessCodeField={setShowAccessCodeField} />
                        ) : <></>}
                   
                    <main is="x3d" id="l-page-content main-content">                  
                            <div className="row l-page-container">
                                <div
                                    style={{
                                        backgroundImage: `url(${provisional})`,
                                    }}
                                    id="main-left-bg"
                                ></div>
                                <div className="pss-right-content pss2-right-content">
                                    <h2>Your Identity Protection Begins Today!</h2>
                                    <div className="receipt-code-copy pss2-receipt-code-copy">For verification purposes, please provide the information requested below.</div>
                                    <form id="form-member-login" onSubmit={handleSubmit(onSubmit)}>
                                        <div className="input-content pss2-input-content">
                                            <div className="form-row pss-forms">
                                                <div className="form-label">
                                                    <label className="access-code-label pss2-access-code-label" htmlFor="firstName">
                                                        First Name
                                                    </label>
                                                </div>
                                                <div className="form-input">
                                                    <input
                                                        aria-required="true"
                                                        className="access-code-input-pin"
                                                        type="text"
                                                        id="firstName"
                                                        name="firstName"
                                                        onChange={handleInputChange}
                                                        ref={register({
                                                            required: true,
                                                            maxLength: 100,
                                                        })}
                                                    />
                                                </div>
                                                {errors.firstName && errors.firstName.type === "required" && (
                                                    <div className="form-row">
                                                        <div role="alert" className="col-xs-12 col-no-gutter">
                                                            <span className="error-msg">First Name is required</span>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="form-row pss-forms">
                                                <div className="form-label">
                                                    <label className="access-code-label pss2-access-code-label" htmlFor="lastName">
                                                        Last Name
                                                    </label>
                                                </div>
                                                <div className="form-input">
                                                    <input
                                                        aria-required="true"
                                                        className="access-code-input-pin"
                                                        type="text"
                                                        id="lastName"
                                                        name="lastName"
                                                        onChange={handleInputChange}
                                                        ref={register({
                                                            required: true,
                                                            maxLength: 100,
                                                        })}
                                                    />
                                                </div>
                                                {errors.lastName && errors.lastName.type === "required" && (
                                                    <div className="form-row">
                                                        <div role="alert" className="col-xs-12 col-no-gutter">
                                                            <span className="error-msg">Last Name is required</span>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="form-row pss-forms">
                                                <div className="form-label">
                                                    <label className="access-code-label pss2-access-code-label" htmlFor="zip">
                                                        ZIP Code
                                                    </label>
                                                </div>
                                                <div className="form-input">
                                                    <input
                                                        aria-required="true"
                                                        className="access-code-input-pin"
                                                        type="text"
                                                        id="zip"
                                                        name="zip"
                                                        onChange={handleInputChange}
                                                        ref={register({
                                                            required: true,
                                                            maxLength: 100,
                                                        })}
                                                    />
                                                </div>
                                                {errors.zip && errors.zip.type === "required" && (
                                                    <div className="form-row">
                                                        <div role="alert" className="col-xs-12 col-no-gutter">
                                                            <span className="error-msg">Zip Code is required</span>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="form-row pss-forms">
                                                <div className="form-label">
                                                    <label className="access-code-label pss2-access-code-label" htmlFor="customerSecret">
                                                        {configurableField}
                                                    </label>
                                                </div>
                                                <div className="form-input">
                                                    <input
                                                        aria-required="true"
                                                        className="access-code-input-pin"
                                                        type="text"
                                                        id="customerSecret"
                                                        name="customerSecret"
                                                        onChange={handleInputChange}
                                                        ref={register({
                                                            required: true,
                                                            maxLength: 100,
                                                        })}
                                                    />
                                                </div>
                                                {errors.customerSecret && errors.customerSecret.type === "required" && (
                                                    <div className="form-row">
                                                        <div role="alert" className="col-xs-12 col-no-gutter">
                                                            <span className="error-msg">{configurableField} is required</span>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="row getstarted-rightcontent">
                                            <input type="submit" onClick={() => handleSubmit(onSubmit)} value="Get Started" className="mobile-button" />
                                            <div className="pss2-right-content-links">
                                                <a href="javascript:void(0)" onClick={() => handleAccessCode()} className="login-link">
                                                    Enter your Access Code
                                                </a>
                                                <a href="/app/login" className="login-link">
                                                    Click here to Log In
                                                </a>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                     </main> 
                    </>  :
                    <>

                    {showAccessCodeField === true ? (
                    <PSSBannerMessage layout={"retailerpsslandingcode"} showAccessCodeField={showAccessCodeField} setShowAccessCodeField={setShowAccessCodeField} />
                    ) : errors.lastName || errors.firstName || errors.zip || errors.customerSecret ? (
                        <PSSBannerMessage layout={"retailerpsslandingerrormessage"} showAccessCodeField={showAccessCodeField} setShowAccessCodeField={setShowAccessCodeField} />
                    ) : <></>}

                    <style dangerouslySetInnerHTML={{ __html: renderStyle }}></style>

                    <div id="retailer-pss-landing" className="enrollmentStart relative">
                            <div id="pss-container-content" className="pssContainerContent">
                                <div className="retailer-pss-page-TMPL9" dangerouslySetInnerHTML={{ __html: renderComp }}></div>
                            </div>
                            <div id="enrollmentStepView" className="enrollmentSteps">                                
                                <div id="pssContentTitle" className="retailer-pss-page-TMPL9" dangerouslySetInnerHTML={{ __html: renderTitle }}></div>
                                <div className="retailer-pss-page-TMPL9" id="PSS2Enrollment">
                                    <form id="form-member-login-retailer" onSubmit={handleSubmit(onSubmit)}>
                                        <div className="lpEnrollmentField fl">
                                            <label className="lpEnrollmentField fl" htmlFor="firstName">First Name
                                                <span className="required" title="Mandatory">
                                                    {" "}
                                                    *
                                                </span>
                                            </label>
                                                <input
                                                    aria-required="true"
                                                    id="firstName"
                                                    name="firstName"
                                                    className="field ep_half_field"
                                                    onChange={handleInputChange}
                                                    ref={register({
                                                        required: true,
                                                        maxLength: 100,
                                                    })} />
                                                {errors.firstName && errors.firstName.type === "required" && (
                                                    <div className="form-row">
                                                        <div role="alert" className="col-xs-12 col-no-gutter">
                                                            <span className="error-msg">First Name is required</span>
                                                        </div>
                                                    </div>
                                                )}
                                        </div>
                                        <div className="lpEnrollmentField fl">
                                            <label className="lpEnrollmentField fl" htmlFor="lastName">Last Name
                                                <span className="required" title="Mandatory">
                                                    {" "}
                                                    *
                                                </span>
                                            </label>
                                            <input
                                                aria-required="true"
                                                name="lastName"
                                                id="lastName"
                                                className="field ep_half_field" 
                                                onChange={handleInputChange}
                                                ref={register({
                                                        required: true,
                                                        maxLength: 100,
                                                    })}/>
                                                {errors.lastName && errors.lastName.type === "required" && (
                                                    <div className="form-row">
                                                        <div role="alert" className="col-xs-12 col-no-gutter">
                                                            <span className="error-msg">Last Name is required</span>
                                                        </div>
                                                    </div>
                                                )}
                                        </div>
                                        <div className="cb"></div>
                                        <div className="lpEnrollmentField fl">
                                            <label htmlFor="zip">Zip Code
                                                <span className="required" title="Mandatory">
                                                    {" "}
                                                    *
                                                </span>
                                            </label>
                                            <input
                                                aria-required="true"
                                                name="zip" id="zip"
                                                onChange={handleInputChange}
                                                className="field ep_half_field"
                                                ref={register({
                                                        required: true,
                                                        maxLength: 100,
                                                    })}/>
                                                {errors.zip && errors.zip.type === "required" && (
                                                    <div className="form-row">
                                                        <div role="alert" className="col-xs-12 col-no-gutter">
                                                            <span className="error-msg">Zip Code is required</span>
                                                        </div>
                                                    </div>
                                                )}
                                        </div>
                                        <div className="lpEnrollmentField fl">
                                            <label htmlFor="customerSecret">{configurableField}
                                                <span className="required" title="Mandatory">
                                                    {" "}
                                                    *
                                                </span>
                                            </label>
                                            <input
                                                aria-required="true"
                                                name="customerSecret"
                                                id="customerSecret"
                                                onChange={handleInputChange}
                                                className="field ep_half_field"
                                                    ref={register({
                                                        required: true,
                                                        maxLength: 100,
                                                    })} />
                                                {errors.customerSecret && errors.customerSecret.type === "required" && (
                                                    <div className="form-row">
                                                        <div role="alert" className="col-xs-12 col-no-gutter">
                                                            <span className="error-msg">{configurableField} is required</span>
                                                        </div>
                                                    </div>
                                                )}
                                        </div>
                                        <div className="cb"></div>                                      
                                        <div className="pssLoginLinkContainer">
                                            <a href={`pss_landing/ProvisionalResponseLandingPage1?RetailerCode=${RetailerCode}`} className="pssLinks" id="redirect-access-code" onClick={() => { window.addToDataLayer({ event: "PSS2 Enter access code" });}} >
                                                    Enter your access code
                                            </a>
                                            <input type="submit" onClick={() => handleClick()} value="Get Started" className="mobileButton getStartedButton" />
                                        </div>
                                   </form>
                                </div>


                            </div>
                        </div>
                    </>
                    }
               
            </React.Fragment>
        );
    }
};
export default MyAccount;
